export const FETCH_JOB = "fetchJob";
export const FETCH_JOB_LIST = "fetchJobs";
export const SAVE_NEW_JOB = "saveNewJob";
export const SAVE_EDITED_JOB = "saveEditedJob";
